module.exports = __webpack_public_path__ + "static/media/03_01_09.a1dc3116.png";